import React, { memo } from 'react';
import { motion } from 'framer-motion';
export const CreditsSection = () => {
  return <section className="py-20 md:py-28 bg-black relative overflow-hidden" data-id="element-1028">
      <div className="absolute inset-0 bg-gradient-to-b from-amber-950/10 to-black opacity-20" data-id="element-1029"></div>
      <div className="container mx-auto px-4 max-w-6xl relative z-10" data-id="element-1030">
        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-20" data-id="element-1031">
          <div className="w-24 h-px bg-amber-400/30 mx-auto mb-8" data-id="element-1032"></div>
          <h2 className="font-serif text-4xl md:text-5xl text-amber-400 tracking-wider uppercase" data-id="element-1033">
            Credits
          </h2>
        </motion.div>
        {/* Presented By */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="mb-20" data-id="element-1034">
          <div className="border border-amber-400/30 p-8 bg-black/40 text-center" data-id="element-1035">
            <h3 className="text-amber-400 font-light text-sm tracking-[0.3em] uppercase mb-4" data-id="element-1036">
              Proudly Presented By
            </h3>
            <div className="w-16 h-px bg-amber-400/30 mx-auto mb-6" data-id="element-1037"></div>
            <p className="text-white text-lg font-light tracking-wider" data-id="element-1038">
              Akal Steel (2005) Inc.
            </p>
          </div>
        </motion.div>
        {/* In Memory */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="mb-24" data-id="element-1039">
          <div className="border-2 border-amber-400/30 p-12 bg-black/60 text-center" data-id="element-1040">
            <h3 className="font-serif text-3xl text-amber-400 mb-8 tracking-wider uppercase" data-id="element-1041">
              In Memory
            </h3>
            <div className="w-20 h-px bg-amber-400/30 mx-auto mb-8" data-id="element-1042"></div>
            <p className="text-white text-sm mb-6 tracking-wider uppercase font-light" data-id="element-1043">
              With Gratitude to Sardar Surinder Kundan Singh
            </p>
            <p className="text-white/70 text-xs mb-6 tracking-wider uppercase font-light leading-relaxed" data-id="element-1044">
              Founding Chairman, Scarborough Gurdwara • Original Sevadar, Art of
              the Sikh Kingdoms (1947-2012)
            </p>
            <p className="text-white/50 text-xs tracking-wider uppercase font-light" data-id="element-1045">
              This work—from the anonymous creator of Sikhiwiki & Turbanizer—is
              created in his memory
            </p>
          </div>
        </motion.div>
        {/* Credits Grid */}
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12" data-id="element-1046">
          {/* Executive Producers */}
          <div data-id="element-1047">
            <h3 className="text-amber-400 font-light text-sm mb-4 tracking-[0.3em] uppercase border-b border-amber-400/30 pb-2" data-id="element-1048">
              Executive Producers
            </h3>
            <p className="text-white/70 text-xs leading-relaxed tracking-wider uppercase font-light" data-id="element-1049">
              Jasvinder Singh
              <br data-id="element-1050" />
              Baljeet Kaur
              <br data-id="element-1051" />
              Harsimran Kaur (M/O Akaash Singh & Baani Kaur)
              <br data-id="element-1052" />
              Aiksimar Singh
              <br data-id="element-1053" />
              JJ Singh Brar
            </p>
          </div>
          {/* Creative Direction */}
          <div data-id="element-1054">
            <h3 className="text-amber-400 font-light text-sm mb-4 tracking-[0.3em] uppercase border-b border-amber-400/30 pb-2" data-id="element-1055">
              Creative Direction
            </h3>
            <p className="text-white/70 text-xs leading-relaxed tracking-wider uppercase font-light" data-id="element-1056">
              Kanwar Singh Dhillon
              <br data-id="element-1057" />
              Inkquisitive
            </p>
          </div>
          {/* Sound Engineering */}
          <div data-id="element-1058">
            <h3 className="text-amber-400 font-light text-sm mb-4 tracking-[0.3em] uppercase border-b border-amber-400/30 pb-2" data-id="element-1059">
              Sound Engineering
            </h3>
            <p className="text-white/70 text-xs leading-relaxed tracking-wider uppercase font-light" data-id="element-1060">
              J-Statik
            </p>
          </div>
          {/* Musical Score */}
          <div data-id="element-1061">
            <h3 className="text-amber-400 font-light text-sm mb-4 tracking-[0.3em] uppercase border-b border-amber-400/30 pb-2" data-id="element-1062">
              Musical Score
            </h3>
            <p className="text-white/70 text-xs leading-relaxed tracking-wider uppercase font-light" data-id="element-1063">
              DJ Singhchronize
            </p>
          </div>
          {/* Historical Consultants */}
          <div data-id="element-1064">
            <h3 className="text-amber-400 font-light text-sm mb-4 tracking-[0.3em] uppercase border-b border-amber-400/30 pb-2" data-id="element-1065">
              Historical Consultants
            </h3>
            <p className="text-white/70 text-xs leading-relaxed tracking-wider uppercase font-light" data-id="element-1066">
              Sarbpreet Singh
              <br data-id="element-1067" />
              Prableen Kamboj
              <br data-id="element-1068" />
              Ajaypal Singh
            </p>
          </div>
          {/* Immersive Technology */}
          <div data-id="element-1069">
            <h3 className="text-amber-400 font-light text-sm mb-4 tracking-[0.3em] uppercase border-b border-amber-400/30 pb-2" data-id="element-1070">
              Immersive Technology
            </h3>
            <p className="text-white/70 text-xs leading-relaxed tracking-wider uppercase font-light" data-id="element-1071">
              Secret Location
              <br data-id="element-1072" />
              ATHINK AI Studio
            </p>
          </div>
          {/* Culinary Direction */}
          <div data-id="element-1073">
            <h3 className="text-amber-400 font-light text-sm mb-4 tracking-[0.3em] uppercase border-b border-amber-400/30 pb-2" data-id="element-1074">
              Culinary Direction
            </h3>
            <p className="text-white/70 text-xs leading-relaxed tracking-wider uppercase font-light" data-id="element-1075">
              Gagan Grewal-Sagoo
              <br data-id="element-1076" />
              Baani Kundan Kaur
            </p>
          </div>
          {/* Partners */}
          <div data-id="element-1077">
            <h3 className="text-amber-400 font-light text-sm mb-4 tracking-[0.3em] uppercase border-b border-amber-400/30 pb-2" data-id="element-1078">
              Partners
            </h3>
            <p className="text-white/70 text-xs leading-relaxed tracking-wider uppercase font-light" data-id="element-1079">
              Ethnicity Matters (Media Partner)
              <br data-id="element-1080" />
              Sikhiwiki
            </p>
          </div>
          {/* Supported By */}
          <div className="md:col-span-2 lg:col-span-3" data-id="element-1081">
            <h3 className="text-amber-400 font-light text-sm mb-4 tracking-[0.3em] uppercase border-b border-amber-400/30 pb-2" data-id="element-1082">
              Supported By
            </h3>
            <p className="text-white/70 text-xs leading-relaxed tracking-wider uppercase font-light mb-6" data-id="element-1083">
              Akal Steel (2005) Inc.
              <br data-id="element-1084" />
              Sikh Heritage Museum of Canada
              <br data-id="element-1085" />
              Sikh Foundation of Canada
            </p>
            <p className="text-amber-400 font-light text-xs tracking-[0.3em] uppercase mb-3" data-id="element-1086">
              Contributing Sikh University Alumni
            </p>
            <p className="text-white/70 text-xs leading-relaxed tracking-wider uppercase font-light" data-id="element-1087">
              IIT Delhi (Delhi, India)
              <br data-id="element-1088" />
              Ivey Business School (London, Canada)
              <br data-id="element-1089" />
              INSEAD (Fontainebleau, France • Singapore)
              <br data-id="element-1090" />
              University of Toronto (Toronto, Canada)
              <br data-id="element-1091" />
              University of Waterloo (Waterloo, Canada)
            </p>
          </div>
          {/* Special Thanks */}
          <div className="md:col-span-2 lg:col-span-3" data-id="element-1092">
            <h3 className="text-amber-400 font-light text-sm mb-4 tracking-[0.3em] uppercase border-b border-amber-400/30 pb-2" data-id="element-1093">
              Special Thanks
            </h3>
            <p className="text-white/70 text-xs leading-relaxed tracking-wider uppercase font-light" data-id="element-1094">
              AKAash Kundan Singh • Baani Kundan Kaur • Amardeep Singh • Jeevan
              Singh • Himmat Singh • Harman Kaur • Bibek Singh • Amandeep
              Dhaliwal • Suresh Singh Bhalla • Sabi Marwah • Lally Marwah • Gary
              Singh • Sat Gosal • Thakral Family (Singapore) • Sidhu Family
              (Singapore) • Sahni Family (Dubai) • Calais Family (Sydney) • Alg
              Family (London) • Mattharu Family (San Francisco) • Butter Chicken
              Cartel (Cancun)
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
};